import { render, staticRenderFns } from "./FormTranscripts.vue?vue&type=template&id=0b9f3f24&scoped=true&"
import script from "./FormTranscripts.vue?vue&type=script&lang=js&"
export * from "./FormTranscripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f3f24",
  null
  
)

export default component.exports